enum QuestionType {
  Date = 'Date',
  Text = 'Free-Form Text',
  Radio = 'Radio Button',
  Checkbox = 'Check Box',
  File = 'File',
  Dropdown = 'Drop Down',
  SubList = 'Sublist',
  Currency = 'Currency',
  DropdownCustomList = 'Drop Down with Netsuite List',
  MultilineText = 'Multi Line Free-Form Text',
  Phone = 'Phone',
  Email = 'Email',
  Country = 'Country',
  State = 'State',
  ZipCode = 'Zip Code',
  Address = 'Address',
  MultiSelectDropDown = 'Multi Select Drop Down',
  CompanyLookup = 'Company Lookup',
}
export default QuestionType;
